import React from "react";
import "./Home.css";
import Product from "./Product"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
      <Carousel className= "home__image"
      autoPlay
      infiniteLoop
      showStatus={false}
      showIndicators={false}
      showThumbs={false}
      interval={2000}
      
      
      >
        
                <div >
                    <img src="https://m.media-amazon.com/images/I/61P1PT-HkpL._SX3000_.jpg" />
                  
                </div>
                <div>
                    <img src="https://m.media-amazon.com/images/I/718rhsspi4L._SX3000_.jpg" />
                   
                </div>
                <div>
                    <img src="https://m.media-amazon.com/images/I/61xIJHjsZAL._SX3000_.jpg" />
                </div>
            </Carousel>
         
        <div className="home__row">
          <Product
            id="12321341"
            // title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            title="Wyze Cam v3 1080p HD
            Indoor/Outdoor Video Camera for
            Security, Pets, Baby Monitor, w/Color
            Night Vision, 2-Way Audio, Works with
            Alexa & Google"
            price={32.98}
            rating={5}
            // image="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._SX325_BO1,204,203,200_.jpg"
            image="https://images-na.ssl-images-amazon.com/images/I/61DJRLNgyWL._AC_SL1500_.jpg"
          />
          <Product
            id="49538094"
            title="New Apple AirTag"
            price={29}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/713xuNx00oS._AC_SL1500_.jpg"
          />
        </div>

        <div className="home__row">

          <Product
            id="4903850"
            title="New Apple Watch Series 6 (GPS, 44mm) - (Product) RED - Aluminum Case with (Product) RED﻿ - Sport Band"
            price={429.99}
            rating={5}
            image="https://images-na.ssl-images-amazon.com/images/I/81LS-PwwQPL._AC_SL1500_.jpg"
          />
          <Product
            id="23445930"
            title="White Gold PlatedWedding Engagement Solitaire Diamond Promise Ring"
            price={249.99}
            rating={5}
            image="https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg"
          />
          <Product
            id="3254354345"
            title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
            price={598.99}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
          />
        </div>
        <div className="home__row">

<Product
  id="4903850"
  title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
  price={199.99}
  rating={3}
  image="https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg"
/>
<Product
  id="23445930"
  title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
  price={98.99}
  rating={5}
  image="https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"
/>
<Product
  id="3254354345"
  title="Mens Cotton Jacket"
  price={598.99}
  rating={4}
  image="https://fakestoreapi.com/img/71li-ujtlUL._AC_UX679_.jpg"
/>
</div>

        <div className="home__row">
          <Product
            id="90829332"
            title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
            price={1094.98}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"
          />
        </div>

      </div>

    </div>
    );
};

export default Home;
